import Reveal from "./Reveal";
import { QuoteButton, CallButton } from "./Buttons";

export default function CTABand({ title, copy, dark = false, quoteLabel = "GET A QUOTE", service, testid = "cta-band" }) {
  return (
    <section data-testid={testid} className={dark ? "bg-charcoal" : "bg-sand"}>
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <Reveal className="max-w-2xl">
            <h2
              className={`font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl ${
                dark ? "text-ivory" : "text-charcoal"
              }`}
            >
              {title}
            </h2>
            {copy && (
              <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-ivory/75" : "text-ink/75"}`}>
                {copy}
              </p>
            )}
          </Reveal>
          <Reveal delay={0.1} className="flex flex-col gap-3 sm:flex-row">
            <QuoteButton
              label={quoteLabel}
              service={service}
              variant={dark ? "light" : "dark"}
              testid={`${testid}-quote-button`}
            />
            <CallButton variant={dark ? "outline-light" : "outline"} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
